module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.pending-accesses')))]), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": _vm.accesses,
      "columns": ['mobileName', 'switchName', 'key_type', 'controllerName'],
      "operations": _vm.operations
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('title.remove'),
      "visible": !!_vm.accessToDelete,
      "width": "30%",
      "before-close": function () {
        _vm.accessToDelete = null
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('remove.message')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.accessToDelete = null
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.deleteModel
    }
  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a11345ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/access/PendingAccessList.vue
// module id = 1181
// module chunks = 2